import { useReportOnce } from "@/hooks/useReportOnce";
import { reportUnexpectedError } from "@/lib/errors";

/**
 * Report a failed load once, for a surface that shows a friendly message instead
 * of the error itself.
 *
 * The error is the occurrence: reported once when it appears, and again only
 * after it has cleared and a later failure arrives. Use it for an error read from
 * a query while rendering; a `catch` handler should call `handleActionError`
 * directly, since it already runs once per failure.
 *
 * @param error - the query's error, or null/undefined while it has none
 * @param boundary - names the surface in error tracking, e.g. "orders page"
 */
export function useReportLoadFailure(error: unknown, boundary: string): void {
  useReportOnce(error ? "failed" : null, () =>
    reportUnexpectedError(error, boundary)
  );
}
